import EventHubMixin from '@/mixins/EventHub.js'
import APIMixin from '@/mixins/API.js'

import AppPicture from '@/components/app-picture'
import AppIconArrow from '@/components/app-icon-arrow'

export default
{
    name: 'app-gallery',

    mixins:
    [
        EventHubMixin,
        APIMixin
    ],

    components:
    {
        AppPicture,
        AppIconArrow
    },

    data()
    {
        return {
            active: false,
            content: null,
            index: 0,
            canLoop: true
        }
    },

    watch:
    {
        $route()
        {
            this.active = false
        }
    },

    created()
    {
        this.canChange = true
    },

    mounted()
    {
        this.setGesture()

        this.$eventHub.$on('gallery.activate', this.activate)
        this.$eventHub.$on('gallery.deactivate', this.deactivate)

        this.$eventHub.$on('headerTrigger.click', (data) =>
        {
            if(data.action === 'deactivateGallery')
            {
                this.deactivate()
            }
        })
    },

    destroyed()
    {
        this.$eventHub.$emit('gallery.destroyed')
    },

    methods:
    {
        activate(galleryId, imageIndex = 0)
        {
            // Reset content
            this.content = null

            // Set index
            this.index = imageIndex

            // Fetch page content
            this.fetch(`galleries/${galleryId}`, { per_page: 1000 }, (data) =>
            {
                this.content = data
            })

            // Header trigger
            this.$eventHub.$emit('headerTrigger.setState', { state: 'close', event: { action: 'deactivateGallery' } })

            // Header logo
            this.$eventHub.$emit('headerLogo.setState', { state: 'hidden' })

            // Add event listeners
            this.$el.addEventListener('touchstart', this.gesture.callbacks.touchstart, { passive: true })
            window.addEventListener('keydown', this.gesture.callbacks.keydown)

            // Lock scroll
            this.$eventHub.$emit('main.lockScroll')

            // Activate
            this.active = true
        },

        deactivate()
        {
            // Unlock scroll
            this.$eventHub.$emit('main.unlockScroll')

            // Header trigger
            this.$eventHub.$emit('headerTrigger.prevState')

            // Header logo
            this.$eventHub.$emit('headerLogo.prevState')

            // Remove event listeners
            this.$el.removeEventListener('touchstart', this.gesture.callbacks.touchstart, { passive: true })
            window.removeEventListener('keydown', this.gesture.callbacks.keydown)

            // Deactivate
            this.active = false
        },

        setGesture()
        {
            this.gesture = {}
            this.gesture.callbacks = {}

            /**
             * Touch
             */
            this.gesture.touch = {}
            this.gesture.touch.x = 0
            this.gesture.touch.start = {}
            this.gesture.touch.start.x = 0

            this.gesture.callbacks.touchstart = (event) =>
            {
                this.gesture.touch.x = event.touches[0].pageX
                this.gesture.touch.start.x = this.gesture.touch.x

                this.$el.addEventListener('touchmove', this.gesture.callbacks.touchmove)
                this.$el.addEventListener('touchend', this.gesture.callbacks.touchend)
            }
            this.gesture.callbacks.touchmove = (event) =>
            {
                this.gesture.touch.x = event.touches[0].pageX
            }
            this.gesture.callbacks.touchend = () =>
            {
                const distance = this.gesture.touch.x - this.gesture.touch.start.x

                if(Math.abs(distance) > 12)
                {
                    if(distance > 0)
                    {
                        this.previous()
                    }
                    else
                    {
                        this.next()
                    }
                }

                this.$el.removeEventListener('touchmove', this.gesture.callbacks.touchmove, { passive: true })
                this.$el.removeEventListener('touchend', this.gesture.callbacks.touchend, { passive: true })
            }


            /**
             * Keyboard
             */
            this.gesture.callbacks.keydown = (event) =>
            {
                if(event.keyCode === 39)
                {
                    this.next()
                }
                else if(event.keyCode === 37)
                {
                    this.previous()
                }
            }
        },

        next()
        {
            let index = this.index + 1

            if(index > this.content.acf.images.length - 1)
            {
                if(this.canLoop)
                {
                    index = 0
                }
                else
                {
                    index = this.content.acf.images.length - 1
                }
            }

            this.goTo(index)
        },

        previous()
        {
            let index = this.index - 1

            if(index < 0)
            {
                if(this.canLoop)
                {
                    index = this.content.acf.images.length - 1
                }
                else
                {
                    index = 0
                }
            }

            this.goTo(index)
        },

        goTo(index, force = false)
        {
            // Same index an no force
            if(index === this.index && !force)
            {
                return
            }

            // Can't change
            if(!this.canChange)
            {
                return
            }

            this.canChange = false

            window.setTimeout(() =>
            {
                this.canChange = true
            }, 500)

            this.index = index
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-gallery/script.js